import React from "react";
import { PRODUCT_NAME } from "../../data/siteConfig";
import { specRows } from "../../data/content";
export function UnitSection() {
  return <section id="unit" aria-labelledby="unit-title" className="scroll-mt-20 bg-navy" data-id="element-231" data-mp="2aw7smo4v1zat">
      <div className="container-x grid gap-10 py-14 sm:py-20 lg:grid-cols-12 lg:gap-16 lg:py-28" data-id="element-232" data-mp="2oncw61bcnbqf">
        <div className="lg:col-span-5" data-id="element-233" data-mp="2jpbar9qgb0bs">
          <p className="eyebrow" data-id="element-234" data-mp="1vz7bfekapmql">The unit</p>
          <h2 id="unit-title" className="mt-4 font-display text-[clamp(1.9rem,8vw,3.6rem)] font-extrabold leading-[0.98] text-ice lg:text-[clamp(2rem,5vw,3.6rem)]" data-id="element-235" data-mp="1vzyslkd5bhxc">
            {PRODUCT_NAME}
          </h2>
          <p className="mt-5 max-w-[32rem] text-[16px] leading-[1.7] text-ice/80 sm:mt-6 sm:text-[17px]" data-id="element-236" data-mp="25v0k2muw8w33">
            An original, done-for-you beginner floor-hockey unit: 12 structured lessons you can teach in sequence and adapt around your own classes.
          </p>
          <p className="mt-8 max-w-[32rem] border-l-[3px] border-orange pl-4 text-[15px] leading-relaxed text-ice/80" data-id="element-237" data-mp="3ccxdkfruu0xl">
            <strong className="font-bold text-ice" data-id="element-238" data-mp="1r6s1907njsye">School floor hockey</strong> — not field hockey, and not federation-rule competition. Activities are teacher-led and modified for beginners.
          </p>
        </div>

        <div className="lg:col-span-6 lg:col-start-7" data-id="element-239" data-mp="261y79n6qzrrq">
          <h3 className="eyebrow text-ice/70" data-id="element-240" data-mp="261g4s8thshbd">Bundle specification</h3>
          <dl className="mt-4 border-t-2 border-cyan" data-id="element-241" data-mp="18eza7bc58htb">
            {specRows.map(row => <div key={row.term} className="grid gap-1 border-b border-white/10 py-4 sm:grid-cols-[150px_1fr] sm:gap-6 sm:py-5" data-id="element-242" data-mp="1dchkb51wd32w">
                <dt className="text-[13px] font-semibold text-ice/65 sm:text-sm" data-id="element-243" data-mp="1iasuxi00nhm6">{row.term}</dt>
                <dd className="text-[16px] font-bold leading-snug text-ice sm:text-[17px]" data-id="element-244" data-mp="1n3vnpnwyyn1b">{row.detail}</dd>
              </div>)}
          </dl>
        </div>
      </div>
    </section>;
}